export default {
    setSelectedSettingsSidemenu(state, payload) {
        state.selectedSettingsSidemenu = payload;
    },

    unsetSelectedSettingsSidemenu(state) {
        state.selectedSettingsSidemenu = "";
    },
    setExternalPluginInfo(state, payload) {
        state.externalPluginInfo = payload;
    }
};